var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowAllCalendars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.32531 4.00008C9.49603 3.9995 9.66471 4.03718 9.81896 4.11035C9.9732 4.18352 10.1091 4.29032 10.2167 4.4229L15.7361 11.2794C15.9042 11.4839 15.9961 11.7403 15.9961 12.005C15.9961 12.2697 15.9042 12.5262 15.7361 12.7307L10.0224 19.5872C9.82842 19.8205 9.54969 19.9673 9.24751 19.9952C8.94534 20.023 8.64448 19.9297 8.41111 19.7357C8.17774 19.5418 8.03098 19.263 8.00312 18.9609C7.97526 18.6587 8.06858 18.3578 8.26255 18.1245L13.3706 11.9993L8.43396 5.87419C8.29422 5.70645 8.20546 5.50219 8.17817 5.28559C8.15088 5.06898 8.18621 4.84909 8.27998 4.65193C8.37375 4.45478 8.52203 4.28861 8.70729 4.17309C8.89254 4.05757 9.107 3.99753 9.32531 4.00008Z",
    fill: "#3D3B3B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAllCalendars);
export default __webpack_public_path__ + "static/media/arrow_all_calendars.ac1921e736620d133a3e905f1d0bc4c6.svg";
export { ForwardRef as ReactComponent };